import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import im1 from "../../images/kitchen/1.jpg";
import im2 from "../../images/kitchen/2.jpg";
import im3 from "../../images/kitchen/3.jpg";
import im4 from "../../images/kitchen/4.jpg";
import sliderimg from "../../images/slider1.png";
import slider4 from "../../images/slider4.png";
import prod3 from "../../images/prod3.png";
import prod4 from "../../images/prod4.png";

const Silder = () => {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  const images = [im1, im2, im3, im4];
  return (
    <Carousel activeIndex={index} onSelect={handleSelect}>
      {images.map((e, index) => (
        <Carousel.Item key={index} className="" interval={2000}>
          <div className="position-relative" style={{ height: "75vh" }}>
            <img className="h-100 w-100" src={e} alt="First slide" />
            <div className="slider-mesg">
              <h3 className="slider-title">نرحب بكم</h3>
              <p className="slider-text mt-5">يلا ناخد جوله</p>
            </div>
          </div>
        </Carousel.Item>
      ))}

      {/* <Carousel.Item className="slider-background2" interval={2000}>
        <div className="d-flex flex-row justify-content-center align-items-center">
          <img
            style={{ height: "296px", width: "313.53px" }}
            className=""
            src={sliderimg}
            alt="First slide"
          />
          <div className="">
            <h3 className="slider-title">هناك خصم كبير</h3>
            <p className="slider-text">خصم يصل ٥٠٪ عند شرائك</p>
          </div>
        </div>
      </Carousel.Item>

      <Carousel.Item className="slider-background3" interval={2000}>
        <div className="d-flex flex-row justify-content-center align-items-center">
          <img
            style={{ height: "296px", width: "373.53px" }}
            className=""
            src={prod3}
            alt="First slide"
          />
          <div className="">
            <h3 className="slider-title">هناك خصم كبير</h3>
            <p className="slider-text">خصم يصل ٥٠٪ عند شرائك</p>
          </div>
        </div>
      </Carousel.Item>

      <Carousel.Item className="slider-background4" interval={2000}>
        <div className="d-flex flex-row justify-content-center align-items-center">
          <img
            style={{ height: "296px", width: "373.53px" }}
            className=""
            src={prod4}
            alt="First slide"
          />
          <div className="">
            <h3 className="slider-title">هناك خصم كبير</h3>
            <p className="slider-text">خصم يصل ٥٠٪ عند شرائك</p>
          </div>
        </div>
      </Carousel.Item> */}
    </Carousel>
  );
};

export default Silder;
